export default __webpack_public_path__ + "static/media/6F29BE9E-8A0D-4145-B5A5-CA4DCF39666B_1_102_o.f495d8ba.jpeg";